import { createFileRoute, redirect } from '@tanstack/react-router'
import { CashSaleDetailScreen } from '@/features/accounting-cash-sales/cash-sale-detail-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/sales-receipts/$cashSaleId/')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.view')) {
      throw redirect({ to: '/accounting/sales-receipts', search })
    }
  },
  component: SalesReceiptDetailRoute,
})

function SalesReceiptDetailRoute() {
  const { cashSaleId } = Route.useParams()
  return <CashSaleDetailScreen cashSaleId={cashSaleId} />
}
